import { YouTubeEmbedProps } from './types';
import { getYouTubeVideoId } from 'utils/youtube';

const YouTubeEmbed = ({ youTubeVideoUrl }: YouTubeEmbedProps) => {
  const videoId = getYouTubeVideoId(youTubeVideoUrl);
  if (!videoId) return null;

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <span className="block my-11 aspect-video rounded-2xl overflow-hidden">
      <iframe
        width="100%"
        height="100%"
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </span>
  );
};

export default YouTubeEmbed;
